module.exports = __webpack_public_path__ + "img/HOTa.fc6dacc3.png";